<template>
	<div>

		<van-nav-bar title="微信支付" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<div style="text-align: center;margin: 100px auto;">
			<van-loading color="#1989fa" vertical>支付中..</van-loading>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		NavBar,
		Loading
	} from 'vant';

	Vue.use(NavBar);
	Vue.use(Loading);
	var time = null
	export default {
		
		created() {
			var str = this.$route.params.str
			str = decodeURIComponent(str)
			var json = JSON.parse(str)
			var url = json.url
			var order_sn = json.sn
			// alert(url)
			// alert(order_sn)
			if (url && order_sn) {
				time = setTimeout(() => {
					this.$dialog.confirm({

						title: '支付',

						message: '如果你已完成付款，请选择\n【<span style="color:red">我已完成支付</span>】',

						confirmButtonText: '我已完成支付',

						beforeClose: (action, done) => {
							if(action == 'confirm'){
								this.$ApiUtil.Order.checkOrder({
									order_sn: order_sn,
								}).then((res) => {
									done(false)
									if (res.status) {
										this.$dialog.alert({
											message: '支付成功'
										}).then(() => {
											localStorage.removeItem('pay_url')
											location.href = '/member-center'
										})
									} else {
										this.$dialog.confirm({
											message: '查询该订单尚未完成支付，是否重新发起支付\n<b style="color:red">如果已支付请忽略</b>',
											confirmButtonText: '重新支付'
										}).then(() => {
											localStorage.removeItem('pay_url')
											location.reload()
										}).catch(() => {
											localStorage.removeItem('pay_url')
											location.href = '/'
										})
									}
								})
							}else{
								localStorage.removeItem('pay_url')
								location.href = '/member-center'
							}
						}

					}).then(() => {
						
					}).catch(() => {
						
					})
				}, 2500)

				if (localStorage.getItem('pay_url') != url) {
					localStorage.setItem('pay_url', url)
					
					var is_ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
					var is_h5plus = navigator.userAgent.toLowerCase().indexOf('html5plus') != -1 ? 1 : 0
					var href = url + '&redirect_url=' + encodeURIComponent(location.href)
					
					
					if(this.$Setting.run_type == 'app' && is_ios && is_h5plus){
						href = url + '&redirect_url=' + encodeURIComponent(this.$Setting.app_scheme + location.href)
					}
					
					location.href = href
				}
			}
		},

		methods: {
			onClickLeft() {
				clearTimeout(timeout)
				this.$router.go(-1)
			},

		}
	}
</script>

<style>
</style>
